import Vue from 'vue';
import AlignmentAdjustmentStyle from './alignment-adjustment-style.module.scss';

const hasResizeObservable = (): boolean => !(typeof ResizeObserver === 'undefined');

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const ViewModel = () => new Vue({
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  data() {
    return {
      clientWidth: 0,
      scrollWidth: Infinity,
    };
  },

  computed: {
    isContentOverflowing(): boolean {
      return this.scrollWidth > this.clientWidth;
    },

    scrollViewStyleClass(): Record<string, boolean> {
      const { ScrollArea, hasOverflownX } = AlignmentAdjustmentStyle;

      return {
        [ScrollArea]: true,
        [hasOverflownX]: this.isContentOverflowing,
      };
    },
  },
});

export class AlignmentAdjustmentProvider {
  private observer: ResizeObserver | null = null;

  private vm: ReturnType<typeof ViewModel>;

  constructor() {
    this.vm = ViewModel();
  }

  mount(elementRoot: Element): void {
    if (!hasResizeObservable()) return;

    this.updateSizing(elementRoot);
    this.observer = new ResizeObserver(([entry]) => {
      this.updateSizing(entry.target);
    });

    this.observer.observe(elementRoot);
  }

  destroy(): void {
    this.observer?.disconnect();
  }

  private updateSizing(element: Element): void {
    const { clientWidth, scrollWidth } = element;
    this.vm.clientWidth = clientWidth;
    this.vm.scrollWidth = scrollWidth;
  }

  get isContentOverflowing(): boolean {
    return this.vm.isContentOverflowing;
  }

  get scrollViewStyleClass(): Record<string, boolean> {
    return this.vm.scrollViewStyleClass;
  }
}
